import { render, staticRenderFns } from "./ads-config-dialog.vue?vue&type=template&id=3ffa9424&"
import script from "./ads-config-dialog.vue?vue&type=script&lang=js&"
export * from "./ads-config-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports